import { render, staticRenderFns } from "./CaseSlaNotification.vue?vue&type=template&id=7e4780b2"
import script from "./CaseSlaNotification.vue?vue&type=script&lang=js"
export * from "./CaseSlaNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports